import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

const recommended = comics.filter(
  (c) =>
    c.tags.some((t) => ['人气', '治愈', '励志', '逆袭'].includes(t)) &&
    c.rating >= 9.2
).slice(0, 6);

export default function RecommendedSection() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
            编辑推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            精选优质韩国漫画，品质保证
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {recommended.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-100 relative mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  title={`${comic.title} - 编辑推荐韩国漫画`}
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-white text-xs line-clamp-2">
                    {comic.description.slice(0, 40)}...
                  </p>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                {comic.title}
              </h3>
              <div className="flex flex-wrap gap-1 mt-1.5">
                {comic.tags.slice(0, 2).map((tag) => (
                  <span
                    key={tag}
                    className="inline-block px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}